export const name ='PageNotFoundController';
export default function PageNotFoundController(
  $window,
  $stateParams
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;
  vm.goHome = goHome;
  vm.$onInit = onInit;

  ///////////

  function onInit() {
    if ($stateParams.reason) {
      vm.reason = $stateParams.reason;
    }
    if ($stateParams.detail) {
      vm.detail = $stateParams.detail;
    }
  }

  function goHome() {
    $window.location.href = '/home';
  }
}
